import './vendor.ts';

import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouterModule } from '@angular/router';
import { Ng2Webstorage } from 'ng2-webstorage';

import { ErrorModule } from './components/error';
import { HomeModule } from './components/home';
import { LoginModule } from './components/login';
import { ManagementModule } from './components/management';
import { AccountModule } from './components/account';
import { FacultyQueuesModule } from './components/faculty-queues';
import { QueuesHandlingModule } from './components/queues-handling';
import { ServiceProviderModule } from './services';

import { customHttpProvider } from './blocks/interceptor/http.provider';
import { PaginationConfig } from './blocks/config/uib-pagination.config';

import { MainComponent, RibbonComponent, PageHeaderComponent, PageFooterComponent } from './components/main';
import { NavbarComponent, ActiveMenuDirective } from './components/main/header/navbar';

import { LAYOUT_ROUTES } from './main.route';

// TODO: Old modules to refactor
import { QueuingSystemSharedModule } from './shared';
import { QueuingSystemAdminModule } from './admin/admin.module';
// import { QueuingSystemEntityModule } from './entities/entity.module';

// jhipster-needle-angular-add-module-import JHipster will add new module here

@NgModule({
    imports: [
        RouterModule.forRoot(LAYOUT_ROUTES, { useHash: true }),
        Ng2Webstorage.forRoot({ prefix: 'qms', separator: '-' }),
        BrowserModule,
        ErrorModule,
        LoginModule,
        HomeModule,
        ServiceProviderModule,
        ManagementModule,
        AccountModule,
        FacultyQueuesModule,
        QueuesHandlingModule,

        // TODO: to refactor
        QueuingSystemSharedModule,
        QueuingSystemAdminModule,
        // QueuingSystemEntityModule, // TODO: old module to remove

        // jhipster-needle-angular-add-module JHipster will add new module here
    ],
    declarations: [
        MainComponent,
        PageHeaderComponent,
        PageFooterComponent,
        NavbarComponent,
        RibbonComponent,
        ActiveMenuDirective
    ],
    providers: [
        customHttpProvider(),
        PaginationConfig
    ],
    bootstrap: [
        MainComponent
    ]
})
export class MainModule {
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/main.module.ts